var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",attrs:{"id":"app"}},[_c('HeaderElem'),_c('div',{staticClass:"app-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('FooterElem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }